















import { Component, Mixins, Prop } from 'vue-property-decorator'

import ModelSetter from '../../../../../../../../../../Mixins/ModelSetter'
import DatePickerInput from '../../../../../../../../../Pi/fields/DatePickerInput/DatePickerInput.vue'
import { PickerFormat } from '../../../../../../../../../Picker/types'
import { ProxyDelayDateType } from '../../../logic/Proxy/ProxyDelayTypes'

@Component({
  components: {
    DatePickerInput
  },
  data() {
    return {
      PickerFormat,
    }
  }
})
export default class DelayDateType extends Mixins<ModelSetter>(ModelSetter) {
  @Prop() delay!: ProxyDelayDateType

  get time(): string {
    return this.delay.time
  }

  set time(time: string) {
    this.delay.setTime(time)
  }
}
